import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import CustomCard from "../../UI/CustomCard/CustomCard";
import StatusBadge from "../../UI/StatusBadge/StatusBadge";
import InfoItems from "../../UI/InfoItems/InfoItems";
import Chip from "../../UI/Chip/Chip";
import TextWithCircleBackground from "../../UI/TextWithCircleBackground/TextWithCircleBackground";
import DateService from "../../../Services/Shared/Date.service";
import ListService from "../../../Services/Shared/List.service";
const PICTURE_TOOLTIP_TEXT = "The rank within the other areas of study for the same area of study type.";
const CurriculumCard = (props) => {
    const curriculums = [];
    const groupedSortedCurriculums = ListService.groupByString(
    // @ts-expect-error - TS2339 - Property 'rank' does not exist on type 'AreaOfStudy'. | TS2339 - Property 'rank' does not exist on type 'AreaOfStudy'.
    [...props.curriculum.areasOfStudy].sort((a, b) => a.rank - b.rank), (aos) => aos.areaOfStudyType.name);
    if (groupedSortedCurriculums.Major &&
        groupedSortedCurriculums.Major.length > 0) {
        curriculums.push({
            label: "Major(s)",
            value: (_jsx("div", { className: "d-flex flex-column", children: groupedSortedCurriculums.Major.map((areaOfStudy, i) => {
                    return (_jsx("div", { children: _jsx(Chip, { picture: (size) => (_jsx(TextWithCircleBackground, { size: size, title: PICTURE_TOOLTIP_TEXT, children: areaOfStudy.rank })), children: areaOfStudy.name }) }, i));
                }) })),
        });
    }
    if (groupedSortedCurriculums.Minor &&
        groupedSortedCurriculums.Minor.length > 0) {
        curriculums.push({
            label: "Minor(s)",
            value: (_jsx("div", { className: "d-flex flex-column", children: groupedSortedCurriculums.Minor.map((areaOfStudy, i) => {
                    return (_jsx("div", { children: _jsx(Chip, { picture: (size) => (_jsx(TextWithCircleBackground, { size: size, title: PICTURE_TOOLTIP_TEXT, children: areaOfStudy.rank })), children: areaOfStudy.name }) }, i));
                }) })),
        });
    }
    if (groupedSortedCurriculums.Concentration &&
        groupedSortedCurriculums.Concentration.length > 0) {
        curriculums.push({
            label: "Concentration(s)",
            value: (_jsx("div", { className: "d-flex flex-column", children: groupedSortedCurriculums.Concentration.map((areaOfStudy, i) => {
                    return (_jsx("div", { children: _jsx(Chip, { picture: (size) => (_jsx(TextWithCircleBackground, { size: size, title: PICTURE_TOOLTIP_TEXT, children: areaOfStudy.rank })), children: areaOfStudy.name }) }, i));
                }) })),
        });
    }
    if (groupedSortedCurriculums.Specialization &&
        groupedSortedCurriculums.Specialization.length > 0) {
        curriculums.push({
            label: "Specialization(s)",
            value: (_jsx("div", { className: "d-flex flex-column", children: groupedSortedCurriculums.Specialization.map((areaOfStudy, i) => {
                    return (_jsx("div", { children: _jsx(Chip, { picture: (size) => (_jsx(TextWithCircleBackground, { size: size, title: PICTURE_TOOLTIP_TEXT, children: areaOfStudy.rank })), children: areaOfStudy.name }) }, i));
                }) })),
        });
    }
    return (_jsx(CustomCard, { title: "Curriculum", className: "mb-3", headerRightContent: _jsxs(_Fragment, { children: [_jsxs("small", { className: "mr-2", children: [DateService.display(moment(props.curriculum.startTerm.startDate)), " ", "- ", DateService.display(moment(props.curriculum.endTerm.endDate))] }), _jsx(StatusBadge, { badgeColor: props.curriculum.active ? "success" : "danger", statusName: props.curriculum.active ? "Active" : "Inactive" })] }), children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 3, numColumnsMd: 3, items: curriculums }) }) }));
};
export default CurriculumCard;
